import {Component, Prop, Vue} from "vue-property-decorator";
import { IVuelidate, Vuelidate } from 'vuelidate';
import { required, email, between, integer, helpers, sameAs } from 'vuelidate/lib/validators';

Component.registerHooks([
    'validations'
])

// @ts-ignore
const matchPattern = (param) => helpers.regex('numeric', param);

@Component
export default class OiForm extends Vue implements IVuelidate {
    @Prop({ type: String })
    action!: string;
    $v: Vuelidate;

    error = false;
    sending = false;
    success = false;

    form = {};
    rules = {};
    formElement: HTMLFormElement;

    validations() {
        return {
            form: this.rules
        }
    }

    mounted() {
        // Remove Honeypot text
        const honeypotField = this.$refs.winnie as HTMLInputElement;
        if (honeypotField) {
            honeypotField.removeAttribute("value");
        }

        this.rules = {};
        this.formElement = this.$refs.form as HTMLFormElement;
        const formFields = [...this.formElement.elements].filter(e=> (e as HTMLFormElement).name && (e as HTMLFormElement).type !== "hidden");

        formFields.forEach( (formField) => {
            const field = formField as HTMLFormElement;
            const fieldId = field.id.indexOf('_') > - 1 ? field.id.split('_')[0] + "_" + field.id.split('_')[1] : field.id;

            if (!this.rules.hasOwnProperty(fieldId)) {
                this.rules[fieldId] = {};

                if (field.required) {
                    if (field.type !== "checkbox" && field.type !== "radio") {
                        this.rules[fieldId].required = required;
                    }
                    if (field.type === 'checkbox') {
                        this.rules[fieldId].required = sameAs(() => true);
                    }
                    if (field.type === 'radio' && !this.rules[fieldId].hasOwnProperty('required')) {
                        this.rules[fieldId].required = required;
                    }
                }
                if (field.type === 'email') {
                    this.rules[fieldId].email = email;
                }
                if (field.type === 'number') {
                    this.rules[fieldId].integer = integer;

                    if (field.min && field.max) {
                        this.rules[fieldId].between = between(Number(field.min), Number(field.max));
                    }
                }
                if (field.pattern) {
                    const regExp = new RegExp('^(' + field.pattern + ')$', 'g');
                    this.rules[fieldId].pattern = matchPattern(regExp);
                }
            }
        });

        /* Add children VueComponents (customSelects) to validations rules */
        const refs = this.$refs;
        for (const key in refs) {
            if ((refs[key] as HTMLElement).dataset && (refs[key] as HTMLElement).dataset.required) {

                if (!this.rules.hasOwnProperty(key)) {
                    this.rules[key] = {};
                    this.rules[key].required = required;
                }
            }
        }
    }

    checkClass(fieldId) {
        return {
            'js-error': this.$v.form[fieldId] && this.$v.form[fieldId].$error,
            'js-valid': this.$v.form[fieldId] && !this.$v.form[fieldId].$invalid && this.$v.form[fieldId].$model && this.$v.form[fieldId].$dirty
        }
    }

    onRulesError(fieldId) {
        return this.$v.form[fieldId] && this.$v.form[fieldId].$error;
    }

    onRuleInvalid(fieldId, rule) {
        return this.$v.form[fieldId] && this.$v.form[fieldId].hasOwnProperty(rule) && !this.$v.form[fieldId][rule];
    }

    onTouch(fieldId) { // for blur or change events
        if(this.$v.form[fieldId]) { this.$v.form[fieldId].$touch(); }
    }

    onComplete(fieldId) { // for autocomplete
        if(this.$v.form[fieldId] && this.$v.form[fieldId].$dirty) { this.$v.form[fieldId].$touch(); }
    }

    sendMail () {
        this.success = false;
        this.error = false;
        this.$v.form.$touch();

        if (!this.$v.form.$invalid && this.formElement.reportValidity()) {
            this.sending = true;
            let data: FormData = new FormData(this.formElement);

            if (this.action) {

                return fetch(
                    this.action,
                    {
                        method: "POST",
                        credentials: "include",
                        body: data,
                    },
                ).then(response => {
                    this.sending = false;
                    if (response.status === 200) {
                        this.success = true;
                        this.error = false;
                    } else {
                        this.success = false;
                        this.error = true;
                    }
                })
                    .catch(() => {
                        this.sending = false;
                        this.success = false;
                        this.error = true;
                        throw new Error("Unable send the request.");
                    });
            } else {
                (this.$refs.form as HTMLFormElement).submit();
                return true;
            }
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/scripts/oi-form.ts